import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';

import { Input } from '../input';

import type { TPhoneInput, IDeps } from './models/models';
import { PhoneInput as Component } from './phone-input';
import styles from './styles/styles.css';

// Компоненту не требуется функционал стайлера
// eslint-disable-next-line styler/check-styler
export const PhoneInput = createWidget<IDeps, TPhoneInput>({
    Input,
    styles,
})(Component);
